/**
 * Full-viewport page wrapper used for standalone flows such as
 * Checkout and tier selection.
 *
 * Author: Maximilien Meyer
 * Copyright © Ircam Amplify 2024-2026
 */

import { HiOutlineXMark } from 'react-icons/hi2'
import { Link } from 'react-router-dom'
import './FullScreenLayout.css'
import Logo from './Logo'

interface FullScreenLayoutProps {
  children: any
  title: string | JSX.Element
  subtitle?: string | JSX.Element
  className?: string
}

export default function FullScreenLayout({
  title,
  subtitle,
  children,
  className,
}: FullScreenLayoutProps) {
  return (
    <div>
      <div className="fullscreen-header">
        <div className="mainHeaderBanner">
          <Link to="/">
            <div className="fullscreen-logo-wrapper">
              <Logo />
            </div>
          </Link>
          <div className="fullscreen-close-btn">
            <Link to="/">
              <HiOutlineXMark size={20} />
            </Link>
          </div>
        </div>
      </div>
      <div className={`fullscreen-content${className ? ` ${className}` : ''}`}>
        <div className="fullscreen-title">{title}</div>
        {subtitle && (
          <div className="fullscreen-subtitle">
            <div className="fullscreen-subtitle-text">{subtitle}</div>
          </div>
        )}
        <div>{children}</div>
      </div>
    </div>
  )
}
